import { CustomElement } from "../../../core/CustomElement";
import SelectSingleVM from "./viewModel";
import SelectItem from "../../../core/interfaces/SelectItem";
import "../field/field";
import "../../icon/index";
import { CCCField } from "../field/field";

export class CCCSelectSingle extends CustomElement {
  $cccField: CCCField;

  static get observedAttributes(): Array<string> {
    return [
      "label",
      "label-edge",
      "label-width",
      "label-align",
      "search",
      "placeholder",
      "min-length",
      "disabled",
      "internal-loading",
      "message",
      "label-weight",
      "display-as-tabs",
    ];
  }

  constructor() {
    super();
    this.templateConfig = {
      template: require("./template.html").default,
      style: require("./style.scss").default,
      viewModel: require("./viewModel"),
    };
    this.setupComponent();
    this.$cccField = this.shadowDom.querySelector("ccc-field");
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: string | null,
    newValue: string | null
  ): void {
    if (attr === "label" && this.$cccField) {
      this.$cccField.label = newValue;
    }
    if (attr === "label-edge" && this.$cccField) {
      this.$cccField.setAttribute("label-edge", newValue);
    }
    if (attr === "label-width" && this.$cccField) {
      this.$cccField.setAttribute("label-width", newValue);
    }
    if (attr === "label-align" && this.$cccField) {
      this.$cccField.setAttribute("label-align", newValue);
    }
    if (attr === "label-weight" && this.$cccField) {
      this.$cccField.setAttribute("label-weight", newValue);
    }
    if (attr === "min-length") {
      this.viewModel.minLength(newValue);
    }
    if (attr === "display-as-tabs") {
      this.viewModel.displayAsTabs(newValue !== null);
    }
    if (attr === "search") {
      const input: HTMLElement = this.shadowDom.querySelector("#input");
      if (newValue) {
        input.setAttribute("readonly", "");
      } else {
        input.removeAttribute("readonly");
      }
    }
    if (attr == "placeholder") {
      this.viewModel.placeholder(newValue);
    }
    if (attr === "disabled") {
      const $input = this.shadowDom.querySelector("input");
      if (newValue === null) {
        this.viewModel.disabled(false);
        $input.removeAttribute("disabled");
        if (this.$cccField) {
          this.$cccField.removeAttribute("disabled");
        }
      } else {
        this.viewModel.disabled(true);
        $input.setAttribute("disabled", "");
        if (this.$cccField) {
          this.$cccField.setAttribute("disabled", "");
        }
      }
    }
    if (attr === "internal-loading" && this.$cccField) {
      if (newValue === null) {
        this.$cccField.removeAttribute("internal-loading");
      } else {
        this.$cccField.setAttribute("internal-loading", newValue);
      }
    }
    if (attr === "message" && this.$cccField) {
      if (newValue === null) {
        this.$cccField.removeAttribute("message");
      } else {
        this.$cccField.setAttribute("message", newValue);
      }
    }
  }

  watchOptions(): void {
    this.viewModel.options(this.state.options);
  }

  public onRawValueChange(
    callback: ((viewModel: SelectSingleVM, val: string) => void) | null,
    timeout: number | null = null
  ): void {
    this.viewModel.onRawValueChange(callback, timeout);
  }

  public onFocusChange(
    callback: ((viewModel: SelectSingleVM, val: boolean) => void) | null
  ): void {
    this.viewModel.onFocusChange(callback);
  }

  public getValue(): SelectItem {
    return this.viewModel.value();
  }

  public onItemSelect(callback: (value: SelectItem) => void): void {
    this.viewModel.onItemSelect(callback);
  }

  public setLoading(loading: boolean): void {
    this.viewModel.displayLoader(loading);
    this.viewModel.disabled(loading);
  }

  public setValue(value: SelectItem): void {
    this.viewModel.selectItem(value);
  }

  public displayPlaceholder(): void {
    this.viewModel.displayPlaceholder();
  }
}

// define component
if (!customElements.get("ccc-select-single")) {
  customElements.define("ccc-select-single", CCCSelectSingle);
}
